<template>
  <div class="setting-form-container" ref="container">
    <div class="open-container">
      <div class="form-item">
        <div class="title" style="font-weight: 500">{{ title }}</div>
        <div class="right">
          <el-switch v-model="info.open" @change="changeOpen"></el-switch>
        </div>
      </div>
      <div class="open-tip">{{ tipMsg }}</div>
    </div>
    <div class="mask-container">
      <div class="mask" v-if="!info.open"></div>
      <div class="apply-on-container">
        <div class="form-title">Apply On</div>
        <div class="form-item">
          <div class="icon schedule-posts"></div>
          <div class="title">{{ singlePostTest }}</div>
          <div class="right">
            <el-switch v-model="info.schedule"></el-switch>
          </div>
        </div>
        <div class="form-item" v-if="currentPublisher.socialNetwork === 1">
          <div class="icon drag-drop"></div>
          <div class="title">Drag & Drop Preview</div>
          <div class="right">
            <el-switch v-model="info.drag"></el-switch>
          </div>
        </div>
        <!-- <div class="form-item"
             :class="{'caption-repost':type === 'caption'}">
          <div class="icon search-repost "></div>
          <div class="title">
            <div class="caption-repost-title">
              <div>Search & Repost</div>
              <div class="warn-icon"
                   v-if="type === 'caption'"
                   @click="searchIconClick"></div>
            </div>
            <el-popover placement="right"
                        width="160"
                        v-model="showPosition"
                        trigger="click">
              <div class="frequency-modal">
                <div class="frequency-item">
                  <el-radio v-model="info.repostContentPosition"
                            :label="1">Apply on Top</el-radio>
                </div>
                <div class="frequency-item">
                  <el-radio v-model="info.repostContentPosition"
                            :label="2">Apply on Bottom</el-radio>
                </div>
              </div>
              <div slot="reference"
                   class="form-tip"
                   v-if="type === 'caption'">{{repostContentPositionText}}</div>
            </el-popover>
          </div>
          <div class="right">
            <el-switch v-model="info.search"></el-switch>
          </div>
        </div> -->
        <div class="form-item">
          <div class="icon bulk-schedule"></div>
          <div class="title">Bulk Schedule</div>
          <div class="right">
            <el-switch v-model="info.bulk"></el-switch>
          </div>
        </div>
      </div>
      <div class="comment-container" ref="comment">
        <div class="form-title">
          <div>{{ typeText }}</div>
          <div class="edit-container">
            <template v-if="edit">
              <div class="edit-btn" @click="cancelClick">Cancel</div>
              <div class="edit-btn" @click="saveClick">Save</div>
            </template>
            <div v-else @click="editClick" class="edit-btn">Edit</div>
          </div>
        </div>
        <div class="select-caption-container" @click="showSelectModal = true">
          <div class="add-icon"></div>
          <div class="select-text">Select {{ typeText }}</div>
        </div>
        <div
          class="comment-item"
          :class="{ select: !edit }"
          v-for="item in defaultList"
          @click="commentClick(item)"
          :key="item.id"
        >
          <div class="text">{{ item.content }}</div>
          <div class="icon-container">
            <div class="del-icon" @click="item.del = true" v-if="edit"></div>
            <template v-else>
              <div v-if="item.is_default_on" class="select-icon"></div>
            </template>
          </div>
        </div>
      </div>
      <select-caption
        v-if="showSelectModal"
        @success="selectSuccess"
        :type="type"
        :socialNetwork="socialNetwork"
        :publisher-id="publisherId"
      ></select-caption>
    </div>
  </div>
</template>

<script>
import {
  getUserContent,
  updateUserContent,
  mulUpdateUserContent,
  updatePublisher,
  permissionValidate,
} from "../../../service/publisher";
import { showErrorMsg } from "../../../utils/errors";
import SelectCaption from "./SelectCaption";
import _ from "lodash";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_SIMPLE,
} from "../../../store/mutation-types";
import { updateUserInfo } from "../../../service/user";

export default {
  name: "DefaultCaptionFormComponent",
  components: { SelectCaption },
  props: {
    publisherId: {
      required: true,
    },
    type: {
      // caption comment
      type: String,
      required: true,
    },
    socialNetwork: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      publisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    title() {
      if (this.socialNetwork === "twitter") {
        if (this.type === "caption") {
          return `Default Tweet`;
        } else {
          return `Default Reply`;
        }
      } else {
        return `Default ${this.type}`;
      }
    },
    tipMsg() {
      if (this.socialNetwork === "twitter") {
        if (this.type === "caption") {
          return `If you have multiple tweets, they will be applied in RANDOM order on your schedules.`;
        } else {
          return `If you have multiple replies, they will be applied in RANDOM order on your schedules.`;
        }
      } else {
        return "If you have multiple comment, they will be applied in RANDOM order on your schedules.";
      }
    },
    repostContentPositionText() {
      if (this.info.repostContentPosition === 1) {
        return "Keep “Repost from @username” on top";
      } else if (this.info.repostContentPosition === 2) {
        return "Keep “Repost from @username” on bottom";
      }
    },
    singlePostTest() {
      if (this.socialNetwork === "twitter") {
        return "Tweets";
      } else {
        return "Single Post Schedule";
      }
    },
    typeText() {
      if (this.socialNetwork === "twitter") {
        if (this.type === "caption") {
          return "Tweets";
        } else {
          return "Reply";
        }
      } else {
        return this.type;
      }
    },
    defaultList() {
      return this.setting.filter((item) => item.is_default && !item.del);
    },
    /**
     * 获取当前登录人权限
     */
    permission() {
      return this.publisher.permissions;
    },
    hasPermission() {
      return this.permission.default_caption;
    },
    currentPublisher() {
      return this.user.linkedInstagramList.find(
        (l) => l.publisherId === this.publisherId
      );
    },
  },
  data() {
    return {
      setting: [],
      edit: false, // 是否处于编辑状态
      showSelectModal: false, // 是否展示选中样式
      info: {
        open: false,
        schedule: false,
        drag: false,
        search: false,
        bulk: false,
        publisherId: this.publisherId,
        repostContentPosition: 0,
      },
      showPosition: false,
    };
  },
  methods: {
    async changeOpen() {
      if (!this.hasPermission) {
        this.info.open = false;
        await permissionValidate({ type: "full" });
      }
    },
    /**
     * search repost 右侧icon点击事件
     */
    async searchIconClick() {
      await this.$alert.show(
        `You can go to Setting page and click "Search & Rpost" to manager repost caption.`
      );
    },
    async selectSuccess() {
      await this.reload();
      this.showSelectModal = false;
    },
    /**
     * 单条comment点击事件 只有在非编辑状态切换选中状态
     */
    async commentClick(item) {
      // 如果非编辑状态 选中状态取法
      if (!this.edit) {
        const loading = this.$loading({ target: this.$refs.comment });
        try {
          // caption类型调取
          const result = await updateUserContent({
            publisherId: this.publisherId,
            ids: [item.id],
            form: { is_default_on: !item.is_default_on },
          });
          item.is_default_on = result.is_default_on;
        } catch (e) {
          showErrorMsg(e);
        } finally {
          loading.close();
        }
      }
    },
    editClick() {
      this.edit = true;
    },
    async saveClick() {
      const loading = this.$loading({ target: this.$refs.comment });
      try {
        let list = _.cloneDeep(this.setting);
        list = list.filter((item) => item.del && item.is_default);
        list.forEach((item) => {
          item.is_default_on = item.is_default = false;
        });
        await mulUpdateUserContent({
          publisherId: this.publisherId,
          form: list,
        });
        this.edit = false;
        const setting = await getUserContent({
          publisherId: this.publisherId,
          type: this.type,
        });
        // 获取
        this.setting = setting;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    cancelClick() {
      this.edit = false;
      this.clearDel();
    },
    clearDel() {
      // 清空删除的标记
      this.setting.forEach((s) => {
        s.del = false;
      });
    },
    async reload() {
      const loading = this.$loading({ target: this.$refs.comment });
      try {
        await updateUserInfo({});
        const setting = await getUserContent({
          publisherId: this.publisherId,
          type: this.type,
        });
        // 获取
        this.setting = setting;
        // 重新更新选中逻辑
        const selectPublisher = this.user.linkedInstagramList.find(
          (link) => link.publisherId === this.publisherId
        );
        if (this.type === "caption") {
          this.info = selectPublisher.defaultCaption;
        } else {
          this.info = selectPublisher.defaultComment;
        }
        this.info.publisherId = this.publisherId;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
  watch: {
    publisherId: {
      async handler(val) {
        if (!val) {
          return;
        }
        this.reload();
      },
      deep: true,
      immediate: true,
    },
    info: {
      async handler(val, old) {
        if (
          !val ||
          !old ||
          val.publisherId !== old.publisherId ||
          !this.hasPermission
        ) {
          return;
        }
        const loading = this.$loading({ target: this.$refs.container });
        try {
          const params = {
            publisherId: val.publisherId,
          };
          const applyOnParams = `${this.info.bulk ? 1 : 0}${
            this.info.search ? 1 : 0
          }${this.info.drag ? 1 : 0}${this.info.schedule ? 1 : 0}`;
          const applyOnStr = parseInt(applyOnParams, 2).toString();
          if (this.type === "caption") {
            params.is_default_caption_on = val.open;
            params.default_caption_apply_on = applyOnStr;
            params.repost_content_position = val.repostContentPosition;
          } else {
            params.is_default_comment_on = val.open;
            params.default_comment_apply_on = applyOnStr;
          }
          this.showPosition = false;
          await updatePublisher(params);
        } catch (e) {
          showErrorMsg(e);
        } finally {
          loading.close();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/style/theme.less";
.frequency-modal {
  padding: 7px 10px 7px 10px;
  .frequency-item {
    padding: 8px 0;
    display: flex;
    align-items: center;
    .frequency-label {
      width: 10px;
    }
  }
}
.setting-form-container {
  overflow: auto;

  .open-container {
    padding-bottom: 20px;
    border-bottom: 1px solid @border-color;

    .open-tip {
      font-size: 14px;
      color: #8c8c8c;
      max-width: 400px;
    }
  }

  .mask-container {
    position: relative;

    .mask {
      background: rgba(255, 255, 255, 0.8);
      position: absolute;
      left: -40px;
      right: -40px;
      top: 0;
      bottom: 0;
      z-index: 1;
    }
  }

  .apply-on-container {
    padding: 20px 0;
    border-bottom: 1px solid @border-color;
  }

  .comment-container {
    padding: 10px 0;

    .edit-container {
      display: flex;

      .edit-btn {
        color: @theme-color;
        cursor: pointer;
        margin-left: 20px;
        font-weight: normal;
      }
    }

    .select-caption-container {
      height: 44px;
      display: flex;
      cursor: pointer;
      border-bottom: 1px solid @border-color;
      align-items: center;

      &:hover {
        opacity: 0.7;
      }

      .add-icon {
        width: 16px;
        height: 16px;
        background-size: contain;
        background-image: url("../../../../public/images/common/add_ins.png");
      }

      .select-text {
        text-transform: capitalize;
        padding-left: 8px;
        font-size: 16px;
        color: @theme-color;
      }
    }

    .comment-item {
      min-height: 64px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid @border-color;
      padding: 10px 0;

      &.select {
        cursor: pointer;
      }

      .text {
        font-size: 14px;
        white-space: pre-wrap;
        word-break: break-all;
        flex: 1;
      }

      .icon-container {
        width: 35px;
        display: flex;
        align-items: center;
        justify-content: center;

        .del-icon {
          width: 15px;
          height: 15px;
          background-size: contain;
          cursor: pointer;
          background-image: url("../../../../public/images/setting/default caption_delete@3x.png");
        }

        .select-icon {
          width: 15px;
          height: 15px;
          background-size: contain;
          cursor: pointer;
          background-image: url("../../../../public/images/setting/default caption_select@3x.png");
        }
      }
    }
  }
}

.form-title {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  text-transform: capitalize;
  font-weight: 500;
}

.form-item {
  display: flex;
  height: 44px;
  align-items: center;

  &.caption-repost {
    height: 60px;

    .icon {
      position: relative;
      bottom: 9px;
    }

    .right {
      position: relative;
      bottom: 9px;
    }

    .caption-repost-title {
      display: flex;
      align-items: center;

      .warn-icon {
        width: 16px;
        height: 16px;
        margin-left: 5px;
        background-image: url("../../../../public/images/schedule_posts/error_grey@3x.png");
        background-size: contain;
        cursor: pointer;

        :hover {
          opacity: 0.7;
        }
      }
    }
  }

  .icon {
    height: 20px;
    width: 20px;
    background-size: contain;
    margin-right: 14px;

    &.schedule-posts {
      background-image: url("../../../../public/images/setting/PhotoLibrary@3x.png");
    }

    &.drag-drop {
      background-image: url("../../../../public/images/setting/DragDrop@3x.png");
    }

    &.search-repost {
      background-image: url("../../../../public/images/setting/Search@3x.png");
    }

    &.bulk-schedule {
      background-image: url("../../../../public/images/setting/BulkSchedule@3x.png");
    }
  }

  .title {
    text-transform: capitalize;

    .form-tip {
      text-transform: none;
      color: #8c8c8c;
      font-size: 14px;
      margin-top: 6px;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
